<div class="offer-bottom-popup">
  <ion-card>
    <ion-card-header class="ion-text-center rate-us">
      <img class="vertical-align-middle" src="./assets/img/rate-3.png" *ngIf="rate < 1">
      <img class="vertical-align-middle" src="./assets/img/rate-1.png" *ngIf="rate == 1">
      <img class="vertical-align-middle" src="./assets/img/rate-2.png" *ngIf="rate == 2">
      <img class="vertical-align-middle" src="./assets/img/rate-3.png" *ngIf="rate == 3">
      <img class="vertical-align-middle" src="./assets/img/rate-4.png" *ngIf="rate == 4">
      <img class="vertical-align-middle" src="./assets/img/rate-5.png" *ngIf="rate == 5">
    </ion-card-header>

    <ion-card-content class="ion-text-center ion-padding ion-margin-top">
      <div *ngIf="page == 1">

        <ion-row class="ion-padding-top">
          <ion-col class="ion-padding-top rate-your-experience">Rate Your Experience</ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-rating [rate]="rate" resettable="true" size="default" (rateChange)="onRateChange($event)">
            </ion-rating>
          </ion-col>
        </ion-row>


        <div class="card-footer">
          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <ion-button (click)="onRate()">Continue</ion-button>
            </ion-col>
          </ion-row>

          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <div class="skip" (click)="closeRateusPopup()">skip</div>
            </ion-col>
          </ion-row>
        </div>
      </div>

      <div *ngIf="page == 2" style="height:200px">

        <ion-row>
          <ion-col class="rate-your-experience ion-margin-bottom-5px">Tell us what can be improved?</ion-col>
        </ion-row>

        <ion-row class="ion-padding-horizontal">
          <ion-col>
            <ion-textarea class="ion-text-left ion-padding-start" placeholder="Please type your feedback" rows="3"
              cols="3"></ion-textarea>
          </ion-col>
        </ion-row>

        <div class="card-footer">
          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <ion-button (click)="onSubmit()">Submit</ion-button>
            </ion-col>
          </ion-row>

          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <div class="skip" (click)="closeRateusPopup()">skip</div>
            </ion-col>
          </ion-row>
        </div>
      </div>

      <div *ngIf="page == 3">
        <div class="">
          <!-- vertical-align-middle width-75 -->
          <ion-row class="ion-padding-top">
            <ion-col class="ion-padding-top rate-your-experience">Thank You for sharing your Experience</ion-col>
          </ion-row>

          <ion-row class="rating-star">
            <ion-col>
              <ion-rating [rate]="rate" size="default" readonly="false"> </ion-rating>
            </ion-col>
          </ion-row>
        </div>

        <div class="card-footer">
          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <ion-button *ngIf="rate > 3" (click)="continue()">Continue</ion-button>
            </ion-col>
          </ion-row>

          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <div class="skip" (click)="closeRateusPopup()">skip</div>
            </ion-col>
          </ion-row>
        </div>
      </div>

      <div *ngIf="page == 4">

        <ion-row class="ion-padding-top">
          <ion-col class="ion-padding-top rate-your-experience rate-on-store">Recommend us to others by rating us on
            <span *ngIf="!isIOS">Play Store</span><span *ngIf="isIOS">App Store</span>
          </ion-col>
        </ion-row>

        <div class="card-footer">
          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <ion-button (click)="onRateusOnStore()">Rate Us</ion-button>
            </ion-col>
          </ion-row>

          <ion-row class="ion-margin-bottom-5px">
            <ion-col>
              <div class="skip" (click)="closeRateusPopup()">skip</div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>